import React from 'react';
import Grid from '@material-ui/core/Grid';

function cond_grid(cols, hide) {
	return hide ? '' : <Grid item xs={ cols } /> ;
}

export {cond_grid} ;